import { TagsState } from './tags.model';

export const INITIAL_TAGS_STATE: TagsState = {
  tags: [],
  loadTagsError: null,
  creatingTag: false,
  createTagError: null,
  lastCreatedTag: null,
};
